import { initCode } from './components/code.js';
import { initBackToTop } from './components/back-to-top.js';
import { initDrawer } from './components/drawer.js';
import { initSlider } from './components/slider.js';
import { initSmoothScroll } from './components/smooth-scroll.js';
import { initViewportClass } from './components/viewport-class.js';

initCode();
initBackToTop();
initDrawer();
initSlider();
initSmoothScroll();
initViewportClass();
